// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var delegatesSection = "distributors-module--delegatesSection--ldHsw";
export var companiesSection = "distributors-module--companiesSection--3XFpZ";
export var contacts = "distributors-module--contacts--3gQf3";
export var region = "distributors-module--region--3PCOy";
export var regionDisabled = "distributors-module--regionDisabled--1mxiZ";
export var contactWrapper = "distributors-module--contactWrapper--jEW22";
export var rootLinesContainer = "distributors-module--rootLinesContainer--5wvQQ";
export var rootLines = "distributors-module--rootLines--JX-rn";
export var filterIndicationContainer = "distributors-module--filterIndicationContainer--2TAMf";
export var infoBlockContainer = "distributors-module--infoBlockContainer--MrW9v";
export var infoBlock = "distributors-module--infoBlock--22kLP";
export var label = "distributors-module--label--2zHpg";
export var info = "distributors-module--info--3GQ0R";
export var infoDescription = "distributors-module--infoDescription--39yaz";
export var infoIcon = "distributors-module--infoIcon--1wJUf";